import { render, staticRenderFns } from "./DocumentacionCompleta.vue?vue&type=template&id=2f0d4cc3"
import script from "./DocumentacionCompleta.vue?vue&type=script&lang=js"
export * from "./DocumentacionCompleta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports